import { useIsPdf } from "@library/components";
import { useMediaLazyLoad, validateDynamicVariable } from "@/shared";
import type { SlideSettingsType } from "../types";
import { SlideBackgroundStyled } from "./Background.styled";
import { BackgroundNode } from "./BackgroundNode";

export const Background = ({ settings }: { settings: SlideSettingsType }) => {
  const { backgroundType, backgroundImage, backgroundVideo } = settings;
  const isPdf = useIsPdf();
  const displayMedia = shouldDisplayBgMedia(isPdf, settings);
  const isImage = backgroundType?.toLowerCase() === "image";
  const isVideo = backgroundType?.toLowerCase() === "video";
  const isBackground =
    (isImage && backgroundImage) || (isVideo && backgroundVideo);

  const { isVisible, setObserverRef } = useMediaLazyLoad();

  let videoSrc = backgroundVideo;
  if (isVideo) {
    const { isDynamic, dynamicVariableParsed } = validateDynamicVariable(
      settings.backgroundDynamicVariable,
    );

    if (
      dynamicVariableParsed &&
      isDynamic &&
      settings.backgroundDynamicVariable
    ) {
      videoSrc = settings.backgroundDynamicVariable;
    }
  }
  return (
    <SlideBackgroundStyled
      ref={(r) => {
        if (!r) return;
        setObserverRef(r);
      }}
      {...STYLED_ATTRIBUTES({ settings })}
      $hasBackground={!!isBackground}
      className="slide-background-FqccRgPxRR tw-absolute tw-inset-0 tw-z-0 tw-h-full tw-w-full"
    >
      {isBackground && displayMedia && (
        <BackgroundNode
          isVisible={isVisible}
          type={isImage ? "image" : "video"}
          url={isImage ? backgroundImage : videoSrc}
        />
      )}
    </SlideBackgroundStyled>
  );
};

//  ======= ATTRIBUTE CREATION =======
const STYLED_ATTRIBUTES = ({ settings }: { settings: SlideSettingsType }) => {
  const { backgroundColor, overlayOpacity, blackAndWhiteFilter } = settings;
  return {
    $backgroundColor: backgroundColor,
    $overlayOpacity: overlayOpacity,
    $blackAndWhiteFilter: !!blackAndWhiteFilter,
  };
};
//  ======= ATTRIBUTE CREATION =======

//  ======= HELPERS =======
const shouldDisplayBgMedia = (pdf: boolean, settings: SlideSettingsType) => {
  const { backgroundColor, overlayOpacity } = settings;
  let displayMedia = true;
  if (!pdf) return displayMedia;
  if (
    !["none", "transparent"].includes(backgroundColor) &&
    overlayOpacity === "100"
  ) {
    displayMedia = false;
  }
  return displayMedia;
};

//  ======= HELPERS =======
